import './styles/tailwind.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPanel from './pages/MainPanel';
import AuthPage from './pages/AuthPage';
import darkBG from './assets/darkBG.png';
import CreateAccount from './pages/CreateAccount';

function App() {
  return (
    <div className="App w-full bg-cover bg-no-repeat bg-center flex items-center justify-center" style={{height: '100vh', backgroundImage: `url(${darkBG})`}}>
      <Router>
          <Routes>
            <Route path="/" element={<AuthPage />} />
            <Route path="/mainPanel" element={<MainPanel />} />
            <Route path="/createAccount" element={<CreateAccount />} />
          </Routes>
      </Router>
    </div>
  );
}

export default App;